export const FETCH_VENUES_REQUEST = "FETCH_VENUES_REQUEST";
export const FETCH_VENUES_SUCCESS = "FETCH_VENUES_SUCCESS";
export const FETCH_VENUES_FAILURE = "FETCH_VENUES_FAILURE";

export const FETCH_VENUES_DETAILS_REQUEST = "FETCH_VENUES_DETAILS_REQUEST";
export const FETCH_VENUES_DETAILS_SUCCESS = "FETCH_VENUES_DETAILS_SUCCESS";
export const FETCH_VENUES_DETAILS_FAILURE = "FETCH_VENUES_DETAILS_FAILURE";

export const FETCH_VENUE_INFRA_REQUEST = "FETCH_VENUE_INFRA_REQUEST";
export const FETCH_VENUE_INFRA_SUCCESS = "FETCH_VENUE_INFRA_SUCCESS";
export const FETCH_VENUE_INFRA_FAILURE = "FETCH_VENUE_INFRA_FAILURE";

export const FETCH_VENUE_INFRA_DETAILS_REQUEST = "FETCH_VENUE_INFRA_DETAILS_REQUEST";
export const FETCH_VENUE_INFRA_DETAILS_SUCCESS = "FETCH_VENUE_INFRA_DETAILS_SUCCESS";
export const FETCH_VENUE_INFRA_DETAILS_FAILURE = "FETCH_VENUE_INFRA_DETAILS_FAILURE";

export const FETCH_BOOKINGS_REQUEST = "FETCH_BOOKINGS_REQUEST";
export const FETCH_BOOKINGS_SUCCESS = "FETCH_BOOKINGS_SUCCESS";
export const FETCH_BOOKINGS_FAILURE = "FETCH_BOOKINGS_FAILURE";

export const FETCH_BOOKED_STATUS_REQUEST = "FETCH_BOOKED_STATUS_REQUEST";
export const FETCH_BOOKED_STATUS_SUCCESS = "FETCH_BOOKED_STATUS_SUCCESS";
export const FETCH_BOOKED_STATUS_FAILURE = "FETCH_BOOKED_STATUS_FAILURE";  

export const FETCH_UPDATE_PAYMENT_REQUEST = "FETCH_UPDATE_PAYMENT_REQUEST";
export const FETCH_UPDATE_PAYMENT_SUCCESS = "FETCH_UPDATE_PAYMENT_SUCCESS";
export const FETCH_UPDATE_PAYMENT_FAILURE = "FETCH_UPDATE_PAYMENT_FAILURE";

export const FETCH_DOWNLOAD_INVOICE_REQUEST = "FETCH_DOWNLOAD_INVOICE_REQUEST";
export const FETCH_DOWNLOAD_INVOICE_SUCCESS = "FETCH_DOWNLOAD_INVOICE_SUCCESS";
export const FETCH_DOWNLOAD_INVOICE_FAILURE = "FETCH_DOWNLOAD_INVOICE_FAILURE";

export const FETCH_SLOT_LEFT_DETAILS_REQUEST = "FETCH_SLOT_LEFT_DETAILS_REQUEST";
export const FETCH_SLOT_LEFT_DETAILS_SUCCESS = "FETCH_SLOT_LEFT_DETAILS_SUCCESS";
export const FETCH_SLOT_LEFT_DETAILS_FAILURE = "FETCH_SLOT_LEFT_DETAILS_FAILURE";
